import { React, useRef, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import moment from 'moment';
import Lottie from 'lottie-react';

import TotalModalWrapper from '../../../Share/Normal/TotalModalWrapper';
import FetchModule from '../../../Share/Network/FetchModule';
import TimeInput from '../../../../Component/ClassManageComponent/TimeInput.js';
import RepeatSelect from '../../../../Component/ClassManageComponent/RepeatSelect.js';
import RepeatWeekSetting from '../../../../Component/ClassManageComponent/RepeatWeekSetting.js';
import NewCalenderInput from '../../../../Component/ClassManageComponent/NewCalenderInput.js';
import NewClassSelectBox from '../../../../Component/ClassManageComponent/NewClassSelectBox.js';
import MaxBookedInput from '../../../../Component/ClassManageComponent/MaxBookedInput.js';
import ReservedMemberInfoBox from './ReservedMemberInfoBox.js';
import QueuedMemberInfoBox from './QueuedMemberInfo.js';

import WhiteTrashIcon from '../../../../image/WhiteTrashIcon.png';
import WhiteArrowImage from '../../../../image/WhiteArrow.png';
import { ReactComponent as LockSvg } from '../../../../image/Lock.svg';
import { ReactComponent as UnlockSvg } from '../../../../image/Unlock.svg';
import { ReactComponent as EmptySignSvg } from '../../../../image/EmptySign.svg';
import { ReactComponent as Check3Svg } from '../../../../image/Check3.svg';
import LoadingAnimation from '../../../../Animation/NewLoading.json';
import ClassSaveLoadingView from './ClassSaveLoadingView.js';
import ClassScheduleCalendar from './ClassScheduleCalendar.js';
import ClassScheduleTooltip from './ClassScheduleTooltip.js';
import TeacherSelectBox from '../../../../Component/ClassManageComponent/TeacherSelectBox.js';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';
import { formatPhoneNumber } from '../../../../Utils/phoneUtils';

export default function ClassAddModal(props) {
  const {
    date,
    scheduleData,
    fallbackLessonColorMap,
    scheduleId,
    teachers,
    onClickDeleteButton,
    cancel,
    options,
    clickedSchedule,

    changedTeacherRendering,
    setChangedTeacherRendering,
    defaultClassTime,
    defaultClassDate,
    defaultApplyWeek
  } = props;

  const history = useHistory();
  const { t, languageMode } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(true);
  const [isRepeat, setIsRepeat] = useState(true);
  const [selectedLesson, setSelectedLesson] = useState({ id: -1, name: t('classManage.selectOption'), time: 0, maxBookedPeople: 0 });
  const lessonColor = useMemo(() => {
    const found = scheduleData.find(s => s.classId === selectedLesson.id);

    if (found?.color) return found.color;
    if (fallbackLessonColorMap) return fallbackLessonColorMap[selectedLesson.id] || '';
    return '';
  }, [scheduleData, selectedLesson.id, fallbackLessonColorMap]);
  const [coachNames, setCoachNames] = useState([]);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [initialTeacherIds, setInitialTeacherIds] = useState(''); // 모달 열렸을 때의 초기 teacherIds

  const [startDate, setStartDate] = useState(moment().format('YYYY.MM.DD'));
  const [originalStartDate, setOriginalStartDate] = useState(moment().format('YYYY-MM-DDTHH:mm:ss'));
  const [endDate, setEndDate] = useState('');
  const [rawEndDate, setRawEndDate] = useState('');
  const [maxBookedPeople, setMaxBookedPeople] = useState(0);

  const [sunday, setSunday] = useState(false);
  const [monday, setMonday] = useState(false);
  const [tuesday, setTuesday] = useState(false);
  const [wednesday, setWednesday] = useState(false);
  const [thursday, setThursday] = useState(false);
  const [friday, setFriday] = useState(false);
  const [saturday, setSaturday] = useState(false);

  const [all, setAll] = useState(true);
  const [one, setOne] = useState(true);
  const [two, setTwo] = useState(true);
  const [three, setThree] = useState(true);
  const [four, setFour] = useState(true);
  const [five, setFive] = useState(true);

  const [isClickedLock, setIsClickedLock] = useState(false);
  const [reserves, setReserves] = useState([]);
  const [queues, setQueues] = useState([]);
  const [maxQueue, setMaxQueue] = useState(20);

  const [rendering, setRendering] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const StartCalenderRef = useRef();
  const TimeRef = useRef();
  const RepeatRef = useRef();
  const RepeatWeekRef = useRef();
  const EndCalenderRef = useRef();

  // 수업 및 스케줄 정보 세팅 //
  useEffect(() => {
    if (scheduleId === -1) {

      if (defaultClassTime !== '') TimeRef.current.setValue(defaultClassTime);
      if (defaultClassDate !== '') StartCalenderRef.current.setValue(defaultClassDate.replaceAll('.', '-'));
      if (defaultApplyWeek !== '') RepeatRef.current.setValue(defaultApplyWeek);

      return;
    }

    for (let i = 0; i < scheduleData.length; i++) {
      if (scheduleData[i].scheduleId === scheduleId) {

        for (let j = 0; j < options.length; j++) {
          if (scheduleData[i].classId === options[j].id) {
            setSelectedLesson(options[j]);
            break;
          }
        }

        StartCalenderRef.current.setValue(date.format('YYYY-MM-DD'));
        setOriginalStartDate(scheduleData[i].classDate);
        TimeRef.current.setValue(scheduleData[i].classTime);
        RepeatRef.current.setValue(scheduleData[i].applyWeek);
        RepeatWeekRef.current.setValue(scheduleData[i].repeatWeek);

        if (scheduleData[i].endDate === '9999-12-31T00:00:00' || scheduleData[i].endDate === '9999-12-31T23:59:59') {
          setIsClicked(true);
          setRawEndDate('');
        }
        else {
          setIsClicked(false);
          setRawEndDate(scheduleData[i].endDate);
          EndCalenderRef.current.setValue(scheduleData[i].endDate.split('T')[0]);
        }

        // classDate ~ endDate가 1일 이하이면 단일 수업 //
        const classDateMoment = moment(scheduleData[i].classDate.split('T')[0]);
        const endDateMoment = moment(scheduleData[i].endDate.split('T')[0]);
        if (endDateMoment.diff(classDateMoment, 'days') <= 1) setIsRepeat(false);
      }
    }
  }, [scheduleData, scheduleId, options, date, defaultClassTime, defaultClassDate, defaultApplyWeek])

  // 수업 시작일과 종료일 검사 //
  useEffect(() => {
    if (startDate === '' || endDate === '') return;

    if (moment(endDate).isBefore(moment(startDate), 'day')) {
      alert(t('classManage.alertInvalidEndDate'));
      setEndDate(startDate);
      return;
    }

  }, [startDate, endDate])

  // 수업 담당 코치 뷰 정리 //
  useEffect(() => {
    if (selectedLesson.id === -1) return;

    const MAX_WIDTH_PX = 111;
    const CHAR_WIDTH_PX = 14;
    let teacherNames = selectedLesson.teachers;
    let isCanceledSchedule = false;

    if (clickedSchedule?.isChangedTeachers !== undefined) isCanceledSchedule = clickedSchedule.isChangedTeachers;

    if (isCanceledSchedule && (clickedSchedule.lessonId === selectedLesson.id)) {
      teacherNames = clickedSchedule.teacherNames;
    }
    // 코치 이름 표시 (너비 제한 적용)
    const coachNames = [];

    let totalLength = 0;

    for (let i = 0; i < teacherNames.length; i++) {
      const name = teacherNames[i];
      const newLength = totalLength + name.length;

      if ((newLength * CHAR_WIDTH_PX < MAX_WIDTH_PX) || i === 0) {
        coachNames.push(name);
        totalLength = newLength;
      }
      else {
        const remaining = teacherNames.length - i;

        if (remaining > 0) coachNames.push(`+${remaining}`);
        break;
      }
    }

    // 선택된 코치 객체 매핑 (Map 사용으로 O(n) 복잡度)
    const teacherMap = new Map(teachers.map(t => [t.teacherName, t]));
    const selectedTeachers = teacherNames
      .map(name => teacherMap.get(name))
      .filter(Boolean);

    setCoachNames(coachNames);
    setSelectedTeachers(selectedTeachers);

    // 초기 teacherIds 저장 (모달 열렸을 때의 상태)
    if (scheduleId !== -1 && selectedTeachers.length > 0) {
      const initialIds = selectedTeachers.map(t => t.teacherId).join(',');
      setInitialTeacherIds(initialIds);
    }
  }, [selectedLesson, teachers, clickedSchedule, scheduleId])

  // 수업 시간뷰 정리 및 API 호출 //
  useEffect(() => {
    if (scheduleId === -1) {
      setMaxBookedPeople(selectedLesson.maxBookedPeople);
      setIsLoading(false);
      return;
    }

    let requestData = {
      scheduleId: scheduleId,
      classDate: date.format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve/status', 'POST', requestData);

        if (responseData.status === 200) {
          setIsClickedLock(responseData.data.isLock);
          setReserves(responseData.data.reserveMembers);
          setQueues(responseData.data.queueMembers);
          setMaxQueue(responseData.data.maxQueue);

          // 최대예약인원 변경 내역이 존재할 경우 //
          if (responseData.data.modifiedMaxBookedPeople !== -1) setMaxBookedPeople(responseData.data.modifiedMaxBookedPeople);
          // 최대 예약인원 변경 내역이 없을경우 //
          else setMaxBookedPeople(selectedLesson.maxBookedPeople);

          setIsLoading(false);
        }
        else setIsLoading(false);
      }
    )();

  }, [scheduleId, date, selectedLesson, rendering])

  // 회원 전화번호 표시 //
  function onViewUserPhone(phone, countryCode) {
    return formatPhoneNumber(phone, countryCode, languageMode) || t('classManage.alertNoPhone');
  }

  // 출석 버튼 텍스트 결정 //
  function onCalcButtonText(data) {
    if (data.status === 1 || data.status === 2) return t('classManage.attendanceConfirmed');
    else return t('classManage.attendanceCheck');
  }

  function CalenderClick(className) {
    if (className === 'StartCalender') EndCalenderRef.current.closeCalender();
    else StartCalenderRef.current.closeCalender();
  }

  function onClickSaveButton() {
    let lessonId = selectedLesson.id;
    let classDate = StartCalenderRef.current.getValue();
    let classTime = TimeRef.current.getValue();
    let applyWeek = RepeatRef.current.getValue();
    let repeatWeek = RepeatWeekRef.current.getValue();
    let endDate = isClicked ? '9999-12-31' : EndCalenderRef.current.getValue();

    // 단일 수업: applyWeek/repeatWeek를 날짜 기반으로 자동 설정, endDate = classDate(+1일) //
    if (!isRepeat && classDate !== '') {
      const dayAbbrevs = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      applyWeek = dayAbbrevs[moment(classDate, 'YYYY.MM.DD').day()] + ',';
      repeatWeek = '0';
      endDate = classDate;
    }

    if (lessonId === undefined || lessonId === -1) {
      alert(t('classManage.alertSelectClass'));
      return;
    }
    else if (classTime === "") {
      alert(t('classManage.alertSetClassTime'));
      return;
    }
    else if (!/^\d{2}:\d{2}-\d{2}:\d{2}$/.test(classTime) || classTime.split('-')[0] > classTime.split('-')[1]) {
      alert(t('classManage.alertInvalidTime'));
      return;
    }
    else if (classDate === '') {
      alert(t('classManage.alertSetClassDate'));
      return;
    }
    else if (isRepeat && applyWeek === '') {
      alert(t('classManage.alertSelectRepeat'));
      return;
    }
    else if (isRepeat && repeatWeek === '') {
      alert(t('classManage.alertSelectRepeatWeek'));
      return;
    }
    // 끝나는 날짜가 과거이거나 같을경우 //
    else if (classDate >= endDate) {
      endDate = moment(classDate, 'YYYY.MM.DD').clone().add(1, 'days').format('YYYY.MM.DD');
    }

    if (isInProgress) {
      alert(t('classManage.alertSaving'));
      return;
    }

    setIsInProgress(true);

    // 브레이크 타임 추가인 경우 //
    if (selectedLesson.id === -2) {
      let requestData = {
        classTime: classTime,
        classDate: classDate.replaceAll('.', '-') + 'T' + '00:00:00',
        applyWeek: applyWeek,
        repeatWeek: repeatWeek,
        endDate: endDate.replaceAll('.', '-') + 'T23:59:59'
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('breaktime/save', 'POST', requestData);

          if (responseData.status === 200) {
            setIsInProgress(false);
            cancel();
          }
          else if (responseData.status === 201) {
            alert(t('classManage.alertDuplicateClass'));
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
          else {
            alert(responseData.error);
            setIsInProgress(false);
          }
        }
      )();
    }
    // 신규 등록
    else if (scheduleId === -1) {
      if (selectedTeachers.length === 0) {
        alert(t('classManage.alertSetCoach'));
        setIsInProgress(false);
        return;
      }

      const teacherIds = selectedTeachers.map(teacher => teacher.teacherId).join(',');
      const teacherNames = selectedTeachers.map(teacher => teacher.teacherName).join(',');

      let data = {
        lessonId: lessonId,
        classTime: classTime,
        classDate: classDate.replaceAll('.', '-') + 'T' + classTime.split('-')[0] + ':00',
        applyWeek: applyWeek,
        repeatWeek: repeatWeek,
        endDate: endDate.replaceAll('.', '-') + 'T23:59:59',
        teacherIds: teacherIds,
        teacherNames: teacherNames,
        modifyMaxBookedPeople: parseInt(maxBookedPeople, 10),
        isReserveLocked: isClickedLock
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('schedule/save/', 'POST', data);

          if (responseData.status === 200) {
            setIsInProgress(false);
            cancel();
          }
          else if (responseData.status === 201) {
            alert(t('classManage.alertDuplicateClass'));
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
          else {
            alert(responseData.error);
            setIsInProgress(false);
          }
        }
      )();
    }
    // 데이터 수정
    else {
      if (selectedTeachers.length === 0) {
        alert(t('classManage.alertSetCoach'));
        setIsInProgress(false);
        return;
      }

      const teacherIds = selectedTeachers.map(teacher => teacher.teacherId).join(',');
      const teacherNames = selectedTeachers.map(teacher => teacher.teacherName).join(',');

      // 순서 상관없이 teacherIds 비교 (모달 열렸을 때의 초기값과 비교)
      const currentIds = teacherIds.split(',').sort().join(',');
      const originalIds = initialTeacherIds.split(',').sort().join(',');
      const isTeacherIdsChanged = currentIds !== originalIds;

      const fetchModule = new FetchModule();
      const promises = [];

      // 수업에서 코치님 변경시 //
      if (isTeacherIdsChanged) {
        let requestData = {
          lessonId: lessonId,
          scheduleId: scheduleId,
          teacherIds: teacherIds,
          teacherNames: teacherNames,
          classTime: classTime,
          classDate: date.format('YYYY-MM-DDT00:00:00')
        }

        promises.push(fetchModule.postDataVersion2('changed_teacher/save', 'POST', requestData));
      }

      // 원본 수업 정원과 같지 않을경우 실행 //
      if (maxBookedPeople !== selectedLesson.maxBookedPeople) {
        let requestData = {
          scheduleId: scheduleId,
          classDate: date.format('YYYY-MM-DDT00:00:00'),
          modifyMaxBookedPeople: maxBookedPeople
        }

        promises.push(fetchModule.postDataVersion2('max_booked/save', 'POST', requestData));
      }

      let data = {
        scheduleId: scheduleId,
        lessonId: lessonId,
        classTime: classTime,
        startDate: classDate.replaceAll('.', '-') + 'T' + classTime.split('-')[0] + ':00',
        classDate: date.format('YYYY-MM-DDT00:00:00'),
        changeApplyWeek: date.format('ddd,'),
        repeatWeek: repeatWeek,
        endDate: endDate.replaceAll('.', '-') + 'T23:59:59'
      }

      const index = scheduleData.findIndex(item => item.scheduleId === scheduleId);

      if (data.lessonId !== scheduleData[index].lessonId
        || data.classTime !== scheduleData[index].classTime
        || data.repeatWeek !== scheduleData[index].repeatWeek
        || data.endDate !== scheduleData[index].endDate) {
        promises.push(fetchModule.postDataVersion2('schedule/modify', 'POST', data));
      }

      // 모든 API 호출 완료 대기
      (
        async () => {
          const results = await Promise.all(promises);

          // 에러 체크
          const failedResponse = results.find(res => res.status !== 200);
          if (failedResponse) {
            if (failedResponse.status === 401) history.push('/');
            else {
              alert(failedResponse.error);
              setIsInProgress(false);
            }
            return;
          }

          // 코치 변경이 있었다면 렌더링 상태 업데이트
          if (isTeacherIdsChanged) {
            setChangedTeacherRendering(!changedTeacherRendering);
          }

          setIsInProgress(false);
          cancel();
        }
      )();
    }
  }

  // Select Box 클릭시 다른 Select Box 끄기
  function selectClickFn(className) {
    if (className === 'category') {
      StartCalenderRef.current.closeCalender();
      EndCalenderRef.current.closeCalender();
    }
    else if (className === 'lesson') {
      StartCalenderRef.current.closeCalender();
      EndCalenderRef.current.closeCalender();
    }
    else if (className === 'start') {
      EndCalenderRef.current.closeCalender();
    }
    else if (className === 'end') {
      StartCalenderRef.current.closeCalender();
    }
  }

  // 삭제버튼 클릭시
  function onClickDelete() {
    let deletedData = {
      scheduleId: scheduleId,
      classDate: date.format('YYYY-MM-DD')
    }

    onClickDeleteButton(deletedData, 'DetailModal');
  }

  // 브레이크 타임 합산으로 인한 컬럼 배경색 변경 //
  function onCalcLessonInfoColumnBackground() {
    if (selectedLesson.id === -2) return theme.line;
    else return theme.subBackground;
  }

  // 수업 정원 늘리기 클릭시 //
  function onClickUpMaxBookedPeople() {
    setMaxBookedPeople(maxBookedPeople + 1);
  }

  // 수업 정원 줄이기 클릭시 //
  function onClickDownMaxBookedPeople() {
    if (maxBookedPeople > 0) setMaxBookedPeople(maxBookedPeople - 1);
  }

  // 회원 이름 또는 사진 클릭시 //
  function onClickMemberProfileOrText(data) {
    if (data.memberId === 0 && data.userId.includes('Guest-')) {
      alert(t('classManage.alertGuestNoAccess'));
      return;
    }
    else window.open('/member/valid/detail/' + data.memberId, '_blank');
  }

  // 회원 예약 취소 버튼 클릭시 //
  function onClickMemberExceptButton(index) {
    if (isInProgress) {
      alert(t('classManage.alertProcessing'));
      return;
    }

    setIsInProgress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('reserve/delete/manage/' + reserves[index].reserveId, 'POST');

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsInProgress(false);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  // 출석 버튼 클릭시 //
  function onClickAttendanceButton(data) {
    if (data.status === 0 || data.status === 3) {
      let requestData = {
        reserveId: data.reserveId,
        status: 1
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/attendance/check/in_modal', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('classManage.alertAttendanceDone'));
            setRendering(!rendering);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    else {
      let requestData = {
        reserveId: data.reserveId,
        status: 3
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/attendance/check/in_modal', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('classManage.alertAttendanceCanceled'));
            setRendering(!rendering);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
  }

  // 예약 대기에서 예약 추가 버튼 클릭시 //
  function onClickAddReserveOnQueue(data) {
    // 맨 위의 대기열인경우 예약자로 변경 //
    if (data.queueIndex === 1) {
      const requestData = {
        reserveQueueId: data.queueId
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/add/zone', 'POST', requestData);

          if (responseData.status === 200) {
            setRendering(!rendering);
          }
        }
      )();
    }
    else {
      // 대기열 순서 변경 //
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve_queue/index/' + data.queueId + '/up', 'POST');

          if (responseData.status === 200) {
            setRendering(!rendering);
          }
        }
      )();
    }
  }

  // 예약 대기 순서 내리기 //
  function onClickDownQueueIndex(data) {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('reserve_queue/index/' + data.queueId + '/down', 'POST');

        if (responseData.status === 200) {
          setRendering(!rendering);
        }
      }
    )();
  }

  // 예약 잠금 버튼 클릭시 //
  function onClickReserveLockButton() {
    if (isInProgress) {
      alert(t('classManage.alertProcessing'));
      return;
    }

    // 신규 등록 모드 — 아직 저장된 schedule 없음 → 로컬 state만 토글 (저장 시 isReserveLocked 필드로 전송) //
    if (scheduleId === -1) {
      setIsClickedLock(!isClickedLock);
      return;
    }

    setIsInProgress(true);

    let requestData = {
      scheduleId: scheduleId,
      classDate: date.format('YYYY-MM-DDT00:00:00')
    }

    // 예약 잠금 풀기 //
    if (isClickedLock) {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/unlock', 'POST', requestData);

          if (responseData.status === 200) {
            setRendering(!rendering);
            setIsClickedLock(false);
            setIsInProgress(false);
          }
          else if (responseData.status === 201) {
            alert(t('classManage.alertInvalidAccess'));
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    // 예약 잠금하기 //
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/lock', 'POST', requestData);

          if (responseData.status === 200) {
            setRendering(!rendering);
            setIsClickedLock(true);
            setIsInProgress(false);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
  }

  return (
    <TotalModalWrapper>
      {
        isInProgress &&
        <ClassSaveLoadingView />
      }
      <ModalView isExistSchedule={scheduleId !== -1}>
        <TitleWrapper isExistSchedule={scheduleId !== -1}>
          {
            scheduleId === -1 ?
              <Title>{t('classManage.addClass')}</Title>
              :
              <Title>{t('classManage.classInfo')}</Title>
          }
          {
            scheduleId !== -1 &&
              <DeleteButtonWrapper>
                <DeletedButton isExistSchedule={scheduleId !== -1} onClick={onClickDelete}>
                  <DeleteImage src={WhiteTrashIcon} />
                </DeletedButton>
              </DeleteButtonWrapper>
          }
        </TitleWrapper>
        <TotalWrapper>
          <TotalInnerWrapper>
            <LayerWrapper>
              <ComponentWrapper width={212} gap={5} >
                <ComponentTitle>{t('classManage.labelClass')}</ComponentTitle>
                <NewClassSelectBox value={selectedLesson} setValue={setSelectedLesson} options={options} selectClickFn={() => selectClickFn('lesson')} color={lessonColor} />
              </ComponentWrapper>
              <ComponentWrapper width={212} gap={5} >
                <ComponentTitle>{t('classManage.labelCoach')}</ComponentTitle>
                <TeacherSelectBoxWrapper>
                  <TeacherSelectBox teachers={teachers} selectedTeachers={selectedTeachers} setSelectedTeachers={setSelectedTeachers} />
                </TeacherSelectBoxWrapper>
              </ComponentWrapper>
              <ComponentWrapper width={100} gap={5} >
                <ComponentTitle>{t('classManage.labelCapacity')}</ComponentTitle>
                <MaxBookedWrapper>
                  <MaxBookedInputWrapper>
                    <MaxBookedInput value={maxBookedPeople} setValue={setMaxBookedPeople} placeholder={selectedLesson.maxBookedPeople} isLock={isClickedLock} />
                  </MaxBookedInputWrapper>
                  <LockButton isLock={isClickedLock} onClick={onClickReserveLockButton}>
                    <UnLock isLock={isClickedLock} />
                    <Lock isLock={isClickedLock} />
                  </LockButton>
                </MaxBookedWrapper>
              </ComponentWrapper>
            </LayerWrapper>
            <DivisionLineWrapper>
              <DivisionLine />
            </DivisionLineWrapper>
            <LayerWrapper>
              <ComponentWrapper gap={5}>
                <ComponentTitle>{t('classManage.scheduleType')}</ComponentTitle>
                <RepeatSettingWrapper>
                  <RepeatBuutton isActive={isRepeat} onClick={() => setIsRepeat(true)}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isRepeat ? theme.subBackground : theme.text}>{t('classManage.recurringClass')}</Text>
                  </RepeatBuutton>
                  <RepeatBuutton isActive={!isRepeat} onClick={() => setIsRepeat(false)}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={!isRepeat ? theme.subBackground : theme.text}>{t('classManage.oneTimeClass')}</Text>
                  </RepeatBuutton>
                </RepeatSettingWrapper>
              </ComponentWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <ComponentWrapper gap={5}>
                <ComponentTitle>{isRepeat ? t('classManage.labelRepeatStartDate') : t('classManage.labelClassDate')}</ComponentTitle>
                <NewCalenderInput
                  ref={StartCalenderRef}
                  value={startDate}
                  setValue={setStartDate}
                  selectClickFn={() => selectClickFn('start')}
                  className='StartCalender'
                  clickFn={CalenderClick}
                  placeholder={t('classManage.placeholderStartDate')}
                  disabled={scheduleId !== -1} />
              </ComponentWrapper>
              <EndDateSectionWrapper isVisible={isRepeat}>
                <ComponentWrapper width={174.67} gap={5}>
                  <LimitWrapper>
                    <ComponentTitle>{t('classManage.labelEndDate')}</ComponentTitle>
                    <LimitButtonWrapper onClick={() => setIsClicked(!isClicked)}>
                      <LimitText>{t('classManage.labelNoLimit')}</LimitText>
                      <LimitButton isClicked={isClicked}>
                        <CheckImage isClicked={isClicked} />
                      </LimitButton>
                    </LimitButtonWrapper>
                  </LimitWrapper>
                  <NewCalenderInput
                    ref={EndCalenderRef}
                    value={endDate}
                    setValue={setEndDate}
                    onUserChange={() => setRawEndDate('')}
                    className='EndCalender'
                    selectClickFn={() => selectClickFn('end')}
                    clickFn={CalenderClick}
                    placeholder={t('classManage.placeholderEndDate')}
                    disabled={isClicked}
                    calenderLeft='215px' />
                </ComponentWrapper>
              </EndDateSectionWrapper>
              <ComponentWrapper gap={5}>
                <ComponentTitle>{t('classManage.labelTime')}</ComponentTitle>
                <TimeInput ref={TimeRef} placeholder="00:00 - 00:00" />
              </ComponentWrapper>
            </LayerWrapper>
            <RepeatSectionWrapper isVisible={isRepeat}>
              <LayerWrapper>
                <ComponentWrapper width={272} gap={5}>
                  <ComponentTitle>{t('classManage.labelRepeatSchedule')}</ComponentTitle>
                  <RepeatSelect
                    ref={RepeatRef}
                    scheduleId={scheduleId}
                    date={date}
                    sunday={sunday}
                    setSunday={setSunday}
                    monday={monday}
                    setMonday={setMonday}
                    tuesday={tuesday}
                    setTuesday={setTuesday}
                    wednesday={wednesday}
                    setWednesday={setWednesday}
                    thursday={thursday}
                    setThursday={setThursday}
                    friday={friday}
                    setFriday={setFriday}
                    saturday={saturday}
                    setSaturday={setSaturday} />
                </ComponentWrapper>
                <ComponentWrapper width={272} gap={5}>
                  <ComponentTitle>{t('classManage.labelRepeatWeek')}</ComponentTitle>
                  <RepeatWeekSetting
                    ref={RepeatWeekRef}
                    all={all}
                    setAll={setAll}
                    one={one}
                    setOne={setOne}
                    two={two}
                    setTwo={setTwo}
                    three={three}
                    setThree={setThree}
                    four={four}
                    setFour={setFour}
                    five={five}
                    setFive={setFive} />
                </ComponentWrapper>
              </LayerWrapper>
            </RepeatSectionWrapper>
            <DivisionLineWrapper>
              <DivisionLine />
            </DivisionLineWrapper>
              <LayerWrapper>
                <ClassScheduleTooltip
                  selectedLesson={selectedLesson}
                  lessonColor={lessonColor}
                  isRepeat={isRepeat}
                  startDate={startDate}
                  originalStartDate={scheduleId !== -1 ? originalStartDate : ''}
                  endDate={endDate}
                  rawEndDate={rawEndDate}
                  sunday={sunday}
                  monday={monday}
                  tuesday={tuesday}
                  wednesday={wednesday}
                  thursday={thursday}
                  friday={friday}
                  saturday={saturday}
                  one={one}
                  two={two}
                  three={three}
                  four={four}
                  five={five} />
                <ClassScheduleCalendar
                  date={date}
                  isRepeat={isRepeat}
                  startDate={startDate}
                  originalStartDate={scheduleId !== -1 ? originalStartDate : ''}
                  endDate={isClicked ? '' : endDate}
                  rawEndDate={isClicked ? '' : rawEndDate}
                  sunday={sunday}
                  monday={monday}
                  tuesday={tuesday}
                  wednesday={wednesday}
                  thursday={thursday}
                  friday={friday}
                  saturday={saturday}
                  one={one}
                  two={two}
                  three={three}
                  four={four}
                  five={five} />
              </LayerWrapper>
          </TotalInnerWrapper>

          {
            scheduleId !== -1 &&
            <ReserveDivisionLineWrapper>
              <ReserveDivisionLine />
            </ReserveDivisionLineWrapper>
          }

          {
            scheduleId !== -1 &&
            <TotalReserveBoxWrapper>
              <StatusInfoBox>
                <MemberReserveListTitleWrapper>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('classManage.reservedMembers')}</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{reserves.length} {t('system.people')} / {maxBookedPeople} {t('system.people')}</Text>
                </MemberReserveListTitleWrapper>
                {
                  isLoading ?
                    <LoadingStatusBox>
                      <LottieWrapper>
                        <Lottie animationData={LoadingAnimation} loop={true} />
                      </LottieWrapper>
                    </LoadingStatusBox>
                    :
                    reserves.length > 0 ?
                      <StatusScrollBox isExistQueue={queues.length > 0}>
                        {
                          reserves.map((memberData, index) => (
                            <ReservedMemberInfoBox
                              key={'Reserve-' + index}
                              memberData={memberData}
                              index={index}
                              totalLength={reserves.length}
                              onViewUserPhone={onViewUserPhone}
                              onCalcButtonText={onCalcButtonText}
                              onClickMemberProfileOrText={onClickMemberProfileOrText}
                              onClickMemberExceptButton={onClickMemberExceptButton}
                              onClickAttendanceButton={onClickAttendanceButton} />
                          ))
                        }
                      </StatusScrollBox>
                      :
                      <EmptyStatusBox>
                        <EmptyImage />
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.line} cursor='default'>{t('classManage.reserveEmpty')}</Text>
                      </EmptyStatusBox>
                }
              </StatusInfoBox>
              {
                queues.length > 0 &&
                <StatusInfoBox>
                  <MemberReserveListTitleWrapper>
                    <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{t('classManage.queueList')}</Text>
                    <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.subText} cursor='default'>{queues.length} {t('system.people')} / {maxQueue} {t('system.people')}</Text>
                  </MemberReserveListTitleWrapper>
                  <QueueScrollBox>
                    {
                      queues.map((memberData, index) => (
                        <QueuedMemberInfoBox
                          key={'Queue-' + index}
                          memberData={memberData}
                          index={index}
                          onViewUserPhone={onViewUserPhone}
                          onClickMemberProfileOrText={onClickMemberProfileOrText}
                          onClickAddReserveOnQueue={onClickAddReserveOnQueue}
                          onClickDownQueueIndex={onClickDownQueueIndex}
                        />
                      ))
                    }
                  </QueueScrollBox>
                </StatusInfoBox>
              }
            </TotalReserveBoxWrapper>
          }
        </TotalWrapper>
        <BottomWrapper isExistSchedule={scheduleId !== -1}>
          <ButtonWrapper>
            <ExitButton onClick={cancel}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('classManage.btnCancel')}</Text>
            </ExitButton>
            <SaveButton onClick={onClickSaveButton}>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('classManage.btnSave')}</Text>
            </SaveButton>
          </ButtonWrapper>
        </BottomWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  box-sizing: border-box;
  width: ${props => props.isExistSchedule ? `1026.5px` : `604px`};

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);

  background-color: ${props => props.theme.subBackground};
`;

const DivisionLineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  padding: 6.75px 10px;

  box-sizing: border-box;
  width: 100%;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: column;
  
  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const DeleteButtonWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 52px;
  height: 24px;
`;

const DeletedButton = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: ${props => props.isExistSchedule ? `-26px -54px 0px 0px` : `-26px -54px 0px 0px`};

  width: 38px;
  height: 38px;

  border-radius: 0px 10px 0px 10px;
  background-color: ${props => props.theme.buttonFill3};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRedAlpha50};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteImage = styled.img`
  width: 26px;
  height: 26px;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 28px;

  width: 100%;

  gap: 20px;
`;

const TotalInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 564px;

  gap: 15px;
`;

const TotalReserveBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 372.5px;
  height: 100%;

  gap: 10px;
`;

const ReserveDivisionLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  padding: 10px 4.5px;

  align-self: stretch;
`;

const ReserveDivisionLine = styled.div`
  width: 1.5px;
  height: 100%;

  border-radius: 2px;
  background-color: ${props => props.theme.line};
`;

const StatusInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const MemberReserveListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 41px;
`;


const StatusScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 100%;
  height: ${props => props.isExistQueue ? '281px' : '100%'};

  overflow-y: auto;
  overflow-x: hidden;

  padding-right: 5px;
  box-sizing: border-box;

  gap: 4px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background: linear-gradient(
			to right,
			transparent 33%,
			${props => props.theme.line} 33%,
			${props => props.theme.line} 66%,
			transparent 66%
		);
	}
`;

const QueueScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 8px;

  width: 100%;
  height: 281px;

  gap: 4px;

  overflow-y: auto;
  overflow-x: hidden;

  padding-right: 5px;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background: linear-gradient(
			to right,
			transparent 33%,
			${props => props.theme.line} 33%,
			${props => props.theme.line} 66%,
			transparent 66%
		);
	}
`;

const LoadingStatusBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 100%;
  height: 434px;
`;


const EmptyStatusBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 645px;

  gap: 10px;
`;

const RepeatSectionWrapper = styled.div`
  overflow: hidden;
  max-height: ${props => props.isVisible ? '300px' : '0'};
  opacity: ${props => props.isVisible ? 1 : 0};
  margin-top: ${props => props.isVisible ? '0' : '-10px'};

  transition: max-height 0.35s ease-in-out, opacity 0.25s ease-in-out, margin-top 0.35s ease-in-out;
`;

const EndDateSectionWrapper = styled.div`
  overflow: hidden;
  flex-shrink: 0;
  max-width: ${props => props.isVisible ? '194.67px' : '0'};
  opacity: ${props => props.isVisible ? 1 : 0};
  margin-left: ${props => props.isVisible ? '0' : '-20px'};

  transition: max-width 0.35s ease-in-out, opacity 0.25s ease-in-out, margin-left 0.35s ease-in-out;
`;


const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 20px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  ${props => props.width ? `width: ${props.width}px; flex-shrink: 0;` : 'flex: 1;'}
  
  gap: ${props => props.gap}px;
`;

const ComponentTitle = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-end;

  margin-top: 10px;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const LimitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const LimitButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const LimitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 2px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckImage = styled(Check3Svg)`
  flex-shrink: 0;
  width: 9px;
  height: 9px;

  opacity: ${props => props.isClicked ? 1 : 0};

  & path { fill: ${props => props.theme.background}; }

  transition: all 0.3s ease-in-out;
`;

const LimitText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 190px;
  height: 40px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TeacherBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;

  gap: 4px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const TeacherSelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 32px;
`;

const TeacherView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 8px 0px 8px;

  max-width: 116px;
  height: 24px;

  border-radius: 6px;
  background-color: ${props => props.theme.primary};

  overflow: hidden;
`;

const MaxBookedWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 5px;
`;

const MaxBookedInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const LockButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 32px;
  min-height: 32px;

  border-radius: 5px;
  background-color: ${props => props.isLock ? props.theme.pointRedAlpha50 : props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRed};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const LessonInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0px 10px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.backgroundColor};

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const Lock = styled(LockSvg)`
  position: absolute;

  opacity: ${props => props.isLock ? 1 : 0};

  width: 15px;
  height: auto;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.white};

    transition: all 0.3s ease-in-out;
  }

  ${LockButton}:hover & path {
    fill: white;
  }

  transition: all 0.3s ease-in-out;
`;

const UnLock = styled(UnlockSvg)`
  opacity: ${props => props.isLock ? 0 : 1};

  width: 15px;
  height: auto;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.line};

    transition: all 0.3s ease-in-out;
  }

  ${LockButton}:hover & path {
    fill: white;
  }

  transition: all 0.3s ease-in-out;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const EmptyImage = styled(EmptySignSvg)`
  width: 148px;
  height: 62px;

  /* 배경 표지판 (root level rect) */
  & > rect {
    fill: ${props => props.theme.buttonFill3};
  }

  /* "EMPTY" 텍스트 */
  & > path {
    fill: ${props => props.theme.white};
  }

  /* 매다는 끈 2개 (g 안의 rects) */
  & > g rect {
    fill: ${props => props.theme.line};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const RepeatSettingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  padding: 10px;

  box-sizing: border-box;
  width: 100%;

  gap: 20px;

  border-radius: 200px;
  background-color: ${props => props.theme.buttonFill};
`;

const RepeatBuutton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 262px;
  height: 32px;

  border-radius: 30px;
  background-color: ${props => props.isActive ? props.theme.primary : props.theme.subBackground};

  cursor: pointer;
  transition: all 0.3s ease-in-out;
`;
